import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";

// Reusable styles for TableCell
const cellStyles = {
  default: {
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  vendorName: {
    minWidth: 150,
    maxWidth: 200,
  },
  customerEmail: {
    minWidth: 150,
    maxWidth: 200,
  },
  customerFullName: {
    minWidth: 150,
    maxWidth: 200,
  },
  createdAt: {
    minWidth: 150,
    maxWidth: 200,
  },
  needTitle: {
    minWidth: 120,
    maxWidth: 150,
  },
  needDescription: {
    minWidth: 200,
    maxWidth: 400,
  },
  header: {
    fontWeight: "bold",
  },
};

// Combine styles for header and body cells
const headerCellStyles = (variant) => ({
  ...cellStyles.default,
  ...cellStyles[variant],
  ...cellStyles.header,
});

const bodyCellStyles = (variant) => ({
  ...cellStyles.default,
  ...cellStyles[variant],
});

const CustomersTable = ({ paginatedMessages }) => (
  <TableContainer component={Paper}>
    <Table sx={{ minWidth: 650 }} aria-label="messages table">
      <TableHead>
        <TableRow>
          <TableCell sx={headerCellStyles("vendorName")}>Vendor Name</TableCell>
          <TableCell sx={headerCellStyles("customerEmail")}>
            Customer Email
          </TableCell>
          <TableCell sx={headerCellStyles("customerFullName")}>
            Customer Full Name
          </TableCell>
          <TableCell sx={headerCellStyles("createdAt")}>Created At</TableCell>
          <TableCell sx={headerCellStyles("needTitle")}>Need Title</TableCell>
          <TableCell sx={headerCellStyles("needDescription")}>
            Need Description
          </TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {paginatedMessages.map((message, index) => (
          <TableRow key={index}>
            <TableCell
              sx={bodyCellStyles("vendorName")}
              title={message.vendor_name}
            >
              {message.vendor_name}
            </TableCell>
            <TableCell
              sx={bodyCellStyles("customerEmail")}
              title={message.customer_email}
            >
              {message.customer_email}
            </TableCell>
            <TableCell
              sx={bodyCellStyles("customerFullName")}
              title={`${message.customer_first_name} ${message.customer_last_name}`}
            >
              {message.customer_first_name} {message.customer_last_name}
            </TableCell>
            <TableCell
              sx={bodyCellStyles("createdAt")}
              title={new Date(message.created_at).toLocaleString()}
            >
              {new Date(message.created_at).toLocaleString()}
            </TableCell>
            <TableCell
              sx={bodyCellStyles("needTitle")}
              title={message.need_title}
            >
              {message.need_title}
            </TableCell>
            <TableCell
              sx={bodyCellStyles("needDescription")}
              title={message.need_description}
            >
              {message.need_description}
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  </TableContainer>
);

export default CustomersTable;
